import React from 'react';

import { Drawer } from '~/components/blocks';
import { OutpatientQuestionnaireEntryDetailFragment } from '~/graphql/generated/graphql';

import { BookedButtons } from './BookedButtons';

type Props = {
  outpatientQuestionnaireEntry?: OutpatientQuestionnaireEntryDetailFragment;
};

export const Footer = React.memo((props: Props) => {
  const { outpatientQuestionnaireEntry } = props;
  const status = outpatientQuestionnaireEntry?.status;
  const isFinished = status === 'finished';

  if (!outpatientQuestionnaireEntry || isFinished) {
    return null;
  }

  return (
    <Drawer.Footer>
      <BookedButtons outpatientQuestionnaireEntry={outpatientQuestionnaireEntry} />
    </Drawer.Footer>
  );
});

Footer.displayName = 'Footer';
